<template>
  <div class="xy-world-cup-btn" ref="componentRef"></div>
</template>

<script setup>
import { info, defaultProps } from './config'
import { useWorldCup } from '@/packages/components/hook/useWorldCup'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)

const {
  componentRef,
  getMatchList,
  placeBet,
  getBetRecords,
  getBetRecordsNextPage,
  getBattleRecord,
  getTodayRankList,
  getYesterdayRankList,
  setSelectedDate,
  prevDatePage,
  nextDatePage,
  setBetResult,
  refreshCurrencyBalance
} = useWorldCup(props)

defineExpose({
  getMatchList,
  placeBet,
  getBetRecords,
  getBetRecordsNextPage,
  getBattleRecord,
  getTodayRankList,
  getYesterdayRankList,
  setSelectedDate,
  prevDatePage,
  nextDatePage,
  setBetResult,
  refreshCurrencyBalance
})
</script>

<style lang="scss" scoped>
.xy-world-cup-btn {
  position: absolute;
  width: 0px;
  height: 0px;
  display: flex;
  top: -10px;
  left: -10px;
  z-index: -999;
}
</style>
